import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _216c6af2 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _de82ee04 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _0775841c = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _60d95d68 = () => interopDefault(import('../pages/service/index.vue' /* webpackChunkName: "pages/service/index" */))
const _1c6e481d = () => interopDefault(import('../pages/admin/category/index.vue' /* webpackChunkName: "pages/admin/category/index" */))
const _18038fab = () => interopDefault(import('../pages/admin/dashboard/index.vue' /* webpackChunkName: "pages/admin/dashboard/index" */))
const _3894f1b2 = () => interopDefault(import('../pages/admin/news/index.vue' /* webpackChunkName: "pages/admin/news/index" */))
const _2a56b100 = () => interopDefault(import('../pages/admin/profile/index.vue' /* webpackChunkName: "pages/admin/profile/index" */))
const _4e9a058c = () => interopDefault(import('../pages/admin/service/index.vue' /* webpackChunkName: "pages/admin/service/index" */))
const _1084fc92 = () => interopDefault(import('../pages/admin/service/category/index.vue' /* webpackChunkName: "pages/admin/service/category/index" */))
const _54a96820 = () => interopDefault(import('../pages/admin/service/opd/index.vue' /* webpackChunkName: "pages/admin/service/opd/index" */))
const _5076f7f3 = () => interopDefault(import('../pages/admin/service/type/index.vue' /* webpackChunkName: "pages/admin/service/type/index" */))
const _78a877b4 = () => interopDefault(import('../pages/admin/news/form/add.vue' /* webpackChunkName: "pages/admin/news/form/add" */))
const _e49f14c0 = () => interopDefault(import('../pages/admin/service/category/indexOld.vue' /* webpackChunkName: "pages/admin/service/category/indexOld" */))
const _f7d2f438 = () => interopDefault(import('../pages/admin/service/type/indexOld.vue' /* webpackChunkName: "pages/admin/service/type/indexOld" */))
const _b3fc7a00 = () => interopDefault(import('../pages/admin/news/form/edit/_id.vue' /* webpackChunkName: "pages/admin/news/form/edit/_id" */))
const _b542f442 = () => interopDefault(import('../pages/admin/service/category/_id.vue' /* webpackChunkName: "pages/admin/service/category/_id" */))
const _1b59bf10 = () => interopDefault(import('../pages/admin/service/category/_idOld.vue' /* webpackChunkName: "pages/admin/service/category/_idOld" */))
const _17b7b89a = () => interopDefault(import('../pages/admin/news/_id.vue' /* webpackChunkName: "pages/admin/news/_id" */))
const _00780a18 = () => interopDefault(import('../pages/admin/service/_id.vue' /* webpackChunkName: "pages/admin/service/_id" */))
const _f5411fb6 = () => interopDefault(import('../pages/service/delivery/_slug.vue' /* webpackChunkName: "pages/service/delivery/_slug" */))
const _2e22c87c = () => interopDefault(import('../pages/service/detail/_slug.vue' /* webpackChunkName: "pages/service/detail/_slug" */))
const _0ae2c6ac = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _6dec6026 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _216c6af2,
    name: "auth"
  }, {
    path: "/home",
    component: _de82ee04,
    name: "home"
  }, {
    path: "/news",
    component: _0775841c,
    name: "news"
  }, {
    path: "/service",
    component: _60d95d68,
    name: "service"
  }, {
    path: "/admin/category",
    component: _1c6e481d,
    name: "admin-category"
  }, {
    path: "/admin/dashboard",
    component: _18038fab,
    name: "admin-dashboard"
  }, {
    path: "/admin/news",
    component: _3894f1b2,
    name: "admin-news"
  }, {
    path: "/admin/profile",
    component: _2a56b100,
    name: "admin-profile"
  }, {
    path: "/admin/service",
    component: _4e9a058c,
    name: "admin-service"
  }, {
    path: "/admin/service/category",
    component: _1084fc92,
    name: "admin-service-category"
  }, {
    path: "/admin/service/opd",
    component: _54a96820,
    name: "admin-service-opd"
  }, {
    path: "/admin/service/type",
    component: _5076f7f3,
    name: "admin-service-type"
  }, {
    path: "/admin/news/form/add",
    component: _78a877b4,
    name: "admin-news-form-add"
  }, {
    path: "/admin/service/category/indexOld",
    component: _e49f14c0,
    name: "admin-service-category-indexOld"
  }, {
    path: "/admin/service/type/indexOld",
    component: _f7d2f438,
    name: "admin-service-type-indexOld"
  }, {
    path: "/admin/news/form/edit/:id?",
    component: _b3fc7a00,
    name: "admin-news-form-edit-id"
  }, {
    path: "/admin/service/category/:id",
    component: _b542f442,
    name: "admin-service-category-id"
  }, {
    path: "/admin/service/category/:idOld",
    component: _1b59bf10,
    name: "admin-service-category-idOld"
  }, {
    path: "/admin/news/:id",
    component: _17b7b89a,
    name: "admin-news-id"
  }, {
    path: "/admin/service/:id",
    component: _00780a18,
    name: "admin-service-id"
  }, {
    path: "/service/delivery/:slug?",
    component: _f5411fb6,
    name: "service-delivery-slug"
  }, {
    path: "/service/detail/:slug?",
    component: _2e22c87c,
    name: "service-detail-slug"
  }, {
    path: "/news/:slug",
    component: _0ae2c6ac,
    name: "news-slug"
  }, {
    path: "/",
    component: _6dec6026,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
